module.exports = __webpack_public_path__ + "static/media/faq3x2.8262fa91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq3x2.png
// module id = 578
// module chunks = 1